import { css } from 'styled-components';

import type { ButtonStyleProps } from '/shared/components/widgets/button/buttonTypes';

import { breakpointDown } from '/shared/styled/Breakpoints';

export default function jumboStyle({ $jumbo = false, $isColumn = false, $hasChildren = false }: ButtonStyleProps) {
  if ($jumbo) {
    return css`
      display: flex;
      border-radius: 1.13rem;
      padding: 2rem 1rem;
      ${
        $isColumn &&
        css`
        padding: 1.5rem 1rem;
        align-items: flex-start;
        ${
          $hasChildren &&
          css`
        > * > *:last-child {
          align-self: stretch;
        }
        `
        }
      `
      }
      ${breakpointDown('mobile')} {
        min-height: 6.666666rem;
        flex: 1;
        padding: 1rem;
        font-size: 1.066666rem;

        > * > * {
          padding: 0 2rem;
          ${
            $isColumn &&
            css`
            padding: 1rem 0;
          `
          }
        }
      }
    `;
  }
}
